<template>
  <div class="aboutUs">
    <page-banner
      :info="{
        url: require('@img/banner_8.jpg'),
        title: $t('about.bannerTitle'),
        text: $t('about.bannerText'),
      }"
    ></page-banner>
    <div class="content">
      <div class="pageTitle">
        <part-title
          class="wow fadeInUp"
          :title="$t('about.title1')"
        ></part-title>
      </div>
      <div class="container">
        <div class="teamInfo">
          <div>
            <div class="contentTitle wow fadeInUp">
              Data-driven Design Optimization System{{ $t("about.p1") }}
            </div>
            <div class="contentText wow fadeInUp" data-wow-delay="0.1s">
              DADOS{{ $t("about.p2") }}/ˈdeɪdəʊs/,Data-driven Design
              Optimization System{{ $t("about.p3") }}
            </div>
            <div class="contentText wow fadeInUp" data-wow-delay="0.2s">
              {{ $t("about.p4") }}
            </div>
          </div>
          <div class="imgStyle">
            <img src="@img/new_building.jpg" class="img01 wow fadeInLeft" />
            <div class="blockStyle wow fadeInRight"></div>
          </div>
        </div>
        <div
          class="teamText wow fadeInUp wow fadeInUp"
          style="margin-bottom: 64px"
          data-wow-delay="0.3s"
        >
          {{ $t("about.p5") }}
        </div>
      </div>
      <team-bar></team-bar>
      <div class="pageTitle">
        <part-title
          class="wow fadeInUp"
          :title="$t('about.title2')"
        ></part-title>
      </div>
    </div>
    <!--  swiper  -->
    <div class="container">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <img src="@img/services/1.jpg" />
          </div>
          <div class="swiper-slide">
            <img src="@img/services/2.jpg" />
          </div>
          <div class="swiper-slide">
            <img src="@img/services/3.jpg" />
          </div>
          <div class="swiper-slide">
            <img src="@img/services/4.png" />
          </div>
          <div class="swiper-slide">
            <img src="@img/services/5.png" />
          </div>
          <div class="swiper-slide">
            <img src="@img/services/6.jpg" />
          </div>
          <div class="swiper-slide">
            <img src="@img/services/7.png" />
          </div>
          <div class="swiper-slide">
            <img src="@img/services/8.gif" />
          </div>
          <div class="swiper-slide">
            <img src="@img/services/9.png" />
          </div>
          <div class="swiper-slide">
            <img src="@img/services/10.png" />
          </div>
          <div class="swiper-slide">
            <img src="@img/services/11.png" />
          </div>
          <div class="swiper-slide">
            <img src="@img/services/12.png" />
          </div>
          <div class="swiper-slide">
            <img src="@img/services/13.png" />
          </div>
        </div>
        <!-- Add Pagination -->
        <div class="swiper-pagination"></div>
      </div>
    </div>
    <page-footer></page-footer>
  </div>
</template>

<script>
import partTitle from "@/components/title";
import pageFooter from "@/components/footer";
import pageBanner from "@/components/banner";
import teamBar from "../components/teamBar";
import { WOW } from "wowjs";
import Swiper from "swiper/swiper-bundle.min.js";
import "swiper/swiper-bundle.min.css";

export default {
  components: {
    pageBanner,
    partTitle,
    pageFooter,
    teamBar,
  },
  data() {
    return {
      wow: "",
    };
  },
  created() {
    this.wow = new WOW({
      animateClass: "animated",
    });
    this.wow.init();
  },
  mounted() {
    let that = this;
    this.mySwiper = new Swiper(".swiper-container", {
      effect: "coverflow",
      grabCursor: true,
      centeredSlides: true,
      slidesPerView: "auto",
      initialSlide: 2,
      coverflowEffect: {
        rotate: 80,
        stretch: 0,
        depth: 100,
        modifier: 1,
        slideShadows: true,
      },
      pagination: {
        el: ".swiper-pagination",
      },
    });
  },
};
</script>

<style lang="less" scoped>
.aboutUs {
  .content {
    position: relative;
    top: 0px;

    .pageTitle {
      padding-top: 70px;
    }

    .container {
      padding-top: 70px;

      .teamInfo {
        display: flex;
        justify-content: space-between;

        .contentTitle {
          width: 539px;
          height: 30px;
          font-size: 22px;
          font-weight: 500;
          color: #5186ff;
          //line-height: 0px;
        }

        .contentText {
          margin-top: 25px;
          width: 700px;
          //height: 359px;
          font-size: 18px;
          font-weight: 400;
          color: rgba(51, 51, 51, 0.75);
          line-height: 28px;
        }

        .imgStyle {
          position: relative;

          .img01 {
            margin-top: 10px;
            margin-right: 10px;
            width: 500px;
            height: 348px;
            border-radius: 12px;
            border: 1px solid rgba(81, 134, 255, 0.2);
          }

          .blockStyle {
            position: absolute;
            top: 0px;
            right: 0px;
            width: 300px;
            height: 300px;
            background: #457dfb;
            z-index: -1;
          }
        }
      }

      .teamText {
        margin: 35px 0;
        font-size: 18px;
        font-weight: 400;
        color: rgba(51, 51, 51, 0.75);
        line-height: 28px;
      }
    }
  }

  .swiper-container {
    margin: 70px 0;
    width: 100%;
    height: 450px;

    .swiper-wrapper,
    .swiper-slide,
    .swiper-slide img {
      width: 320px;
    }

    .swiper-slide {
      position: relative;

      img {
        position: absolute;
        top: 0;
        left: 0;
        z-index: -1;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/about.vue